import type { CheckoutConfig } from '#types/config/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  icon: 'plus'
} satisfies RecursivePartial<CheckoutConfig['loyalty']>
